import ApiService from './ApiService';

class CorporateTraderService {
  async prepareCorporateTrader(payload) {
    try {
      const response = await ApiService.call('/secured/prepare_corporate_trader', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async saveCorporateTrader(payload) {
    try {
      const response = await ApiService.call('/secured/save_corporate_trader', 'POST', payload);

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async submitCorporateTrader(payload) {
    try {
      const response = await ApiService.call('/secured/submit_corporate_trader', 'POST', payload);

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async approveCorporateTrader(payload) {
    try {
      const response = await ApiService.call('/secured/approve_corporate_trader', 'POST', payload);

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCorporateTrader(payload) {
    try {
      const response = await ApiService.call('/secured/get_corporate_trader', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCorporateTraderList(payload) {
    try {
      const response = await ApiService.call('/secured/get_corporate_trader_list', 'POST', payload);

      return {
        traderList: response.result.map(data => {
          return {
            applicationNo: data.applicationInfo.applicationNo,
            clientType: data.applicationInfo.clientType,
            firmName: data.corporateProfile.firmName,
            registrationNo: data.corporateProfile.registrationNo,
            tradingAccountNo: data.corporateTrader.tradingAccountNo,
            primaryEmail: data.corporateTrader.primaryEmail,
            stage: data.corporateTrader.stage,
            traderId: data.corporateTrader.traderId,
            approvedDate: data.approvedDate
          };
        }),
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addDirector(payload) {
    try {
      const response = await ApiService.call('/secured/add_director', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyDirector(payload) {
    try {
      const response = await ApiService.call('/secured/modify_director', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addAuthorizedPerson(payload) {
    try {
      const response = await ApiService.call('/secured/add_authorized_person', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyAuthorizedPerson(payload) {
    try {
      const response = await ApiService.call('/secured/modify_authorized_person', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCompanyOwner(payload) {
    try {
      const response = await ApiService.call('/secured/add_company_owner', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCompanyOwner(payload) {
    try {
      const response = await ApiService.call('/secured/modify_company_owner', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new CorporateTraderService();
